import { Box } from '@mui/material';
import { layoutCardRadius } from '../../theme/colors';

/**
 * Non-interactive elevated card (checkout sections, order summary, etc.).
 * Uses theme shadow[2] — no hover; use ProviderCard for clickable store cards.
 */
const SurfaceCard = ({ children, sx, ...rest }) => (
  <Box
    sx={(theme) => {
      const extra = typeof sx === 'function' ? sx(theme) : sx;
      return {
        display: 'flex',
        p: 3,
        alignItems: 'flex-start',
        gap: 2,
        alignSelf: 'stretch',
        width: '100%',
        bgcolor: 'surface.card',
        borderRadius: layoutCardRadius,
        boxShadow: theme.shadows[2],
        ...extra,
      };
    }}
    {...rest}
  >
    {children}
  </Box>
);

export default SurfaceCard;
